import { createFileRoute, Navigate } from '@tanstack/react-router'

// Privacy lives inside Settings now; this address stays for links already sent.
export const Route = createFileRoute('/app/investor/$id/privacy')({
  component: PrivacyRedirect,
})

function PrivacyRedirect() {
  const { id } = Route.useParams()
  return <Navigate to="/app/investor/$id/settings" params={{ id }} replace />
}
